import { useEffect, useRef } from 'react'
import useDiscountStore from '@/context/DiscountStore'
import { validateDiscountCode, DiscountValidationResponse } from '@/services/discountApi'

export const useDiscountRevalidation = () => {
    const { discountCode, setDiscountValidation, clearDiscount } = useDiscountStore()
    const hasRevalidated = useRef(false)

    useEffect(() => {
        // Only revalidate once per app session
        if (hasRevalidated.current) return
        hasRevalidated.current = true

        // If there's a persisted discount code that's marked as valid, revalidate it
        if (discountCode && discountCode.valid && !discountCode.isLoading) {
            console.log('[DiscountRevalidation] Revalidating persisted discount code:', discountCode.code)

            // Set loading state
            setDiscountValidation({ isLoading: true })

            validateDiscountCode(discountCode.code)
                .then((result: DiscountValidationResponse) => {
                    if (result.valid) {
                        // Update with fresh validation data
                        setDiscountValidation({
                            emailBound: result.emailBound,
                            valid: result.valid,
                            discountType: result.discountType,
                            discountValue: result.discountValue,
                            error: result.error || null,
                            freeAddonIds: result.freeAddonIds,
                            freeAddonTypes: result.freeAddonTypes,
                            isLoading: false
                        })
                        console.log('[DiscountRevalidation] Discount code still valid:', result)
                    } else {
                        // Code is no longer valid, clear it
                        console.log('[DiscountRevalidation] Discount code no longer valid, clearing:', result.error)
                        clearDiscount()
                    }
                })
                .catch((error: Error) => {
                    console.error('[DiscountRevalidation] Failed to revalidate discount code:', error)
                    // On error, clear the discount to be safe
                    clearDiscount()
                })
        }
    }, [discountCode, setDiscountValidation, clearDiscount])
}

export default useDiscountRevalidation 